(function () {
  'use strict';

  var activeTabClasses = [
    'border-[#56A559]',
    'bg-[#56A559]',
    'text-white',
    'shadow-[0_20px_40px_rgba(86,165,89,0.24)]'
  ];
  var inactiveTabClasses = [
    'border-slate-200',
    'bg-white',
    'text-slate-900',
    'hover:border-brand-200',
    'hover:bg-brand-50/40'
  ];
  var activeIconClasses = ['bg-white/12', 'text-white', 'ring-white/20'];
  var inactiveIconClasses = ['bg-brand-50', 'text-brand-600', 'ring-brand-100'];

  function setClassState(element, addClasses, removeClasses) {
    if (!element) return;
    element.classList.remove.apply(element.classList, removeClasses);
    element.classList.add.apply(element.classList, addClasses);
  }

  function activateCoverage(coverage, index) {
    var tabs = Array.prototype.slice.call(coverage.querySelectorAll('.coverage-tab'));
    var panels = Array.prototype.slice.call(coverage.querySelectorAll('.coverage-panel'));

    tabs.forEach(function (tab, tabIndex) {
      var isActive = tabIndex === index;
      var icon = tab.querySelector('[data-role="coverage-icon"]');

      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) {
        setClassState(tab, activeTabClasses, inactiveTabClasses);
        setClassState(icon, activeIconClasses, inactiveIconClasses);
      } else {
        setClassState(tab, inactiveTabClasses, activeTabClasses);
        setClassState(icon, inactiveIconClasses, activeIconClasses);
      }
    });

    panels.forEach(function (panel, panelIndex) {
      var isActive = panelIndex === index;
      panel.classList.toggle('hidden', !isActive);
      panel.classList.toggle('block', isActive);

      var video = panel.querySelector('[data-role="coverage-video"]');
      if (!video) return;

      if (isActive) {
        try {
          video.currentTime = 0;
          var playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(function () {});
        } catch (error) {}
      } else {
        video.pause();
      }
    });
  }

  function initCoverage(coverage) {
    if (coverage.dataset.ffInitialized === 'true') return;
    coverage.dataset.ffInitialized = 'true';

    var tabs = Array.prototype.slice.call(coverage.querySelectorAll('.coverage-tab'));
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateCoverage(coverage, index);
      });
    });

    var selectedIndex = tabs.findIndex(function (tab) {
      return tab.getAttribute('aria-selected') === 'true';
    });
    activateCoverage(coverage, selectedIndex >= 0 ? selectedIndex : 0);
  }

  function initAos() {
    if (!window.AOS) return;

    if (!document.documentElement.dataset.ffAosInitialized) {
      window.AOS.init({
        duration: 700,
        once: true,
        offset: 40,
        easing: 'ease-out-cubic'
      });
      document.documentElement.dataset.ffAosInitialized = 'true';
    } else {
      window.AOS.refreshHard();
    }
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var coverages = [];

    if (context.matches && context.matches('[data-ff-coverage]')) coverages.push(context);
    coverages = coverages.concat(Array.prototype.slice.call(context.querySelectorAll('[data-ff-coverage]')));
    coverages.forEach(initCoverage);
    initAos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
